import React from 'react';
import Select from 'react-select';
import { getText } from 'helpers/app/getText';
import { CUSTOMER_PRIVACY_NOTICE_URL } from 'configs/constants';

const Footer = (props) => {
  const year = new Date().getFullYear();

  const { pageLanguages, defaultLanguage, footerBackgroundColor, footerLinks, footerImageURL, onLanguageChange } = props;

  return (
    <footer className="text-muted-white" style={{ backgroundColor: footerBackgroundColor.length > 0 ? footerBackgroundColor : '#393e46' }}>
      <div className="container">
        <div className="footer-links-box align-center">
          {footerLinks?.map?.((link, idx) => {
            return (
              <div className="mx-2 block" key={idx}>
                <a href={link.linkURL} target="_blank">
                  {defaultLanguage && link?.linkLabel?.[defaultLanguage]?.text}
                </a>
              </div>
            );
          })}
        </div>
        <div className="payment-select text-center align-center">
          <span className="mr-2">
            <img src={footerImageURL} className="footer-img" />
          </span>
        </div>
        <div className="lang-select align-center">
          <Select
            menuPlacement="top"
            isClearable={false}
            value={defaultLanguage?.length > 0 ? pageLanguages.find((lng) => lng.locale === defaultLanguage) : ''}
            options={pageLanguages}
            onChange={onLanguageChange}
            getOptionLabel={(e) => (
              <div className="pos-status-icon-div">
                <img src={e.image} className="pos-status-icon mr-2" />
                <span style={{ marginLeft: 5 }}>{e.label}</span>
              </div>
            )}
          />
        </div>
        <div className="copyright align-center">
          <div className="d-flex justify-content-center flex-row flex-wrap">
            <span>&copy; Vourity AB {year}. All rights reserved.</span>
            <span>
              <a href={CUSTOMER_PRIVACY_NOTICE_URL} className="footer-link" rel="noreferrer" target="_blank">
                {getText('CUSTOMER_PRIVACY_NOTICE')}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
